export default "__VITE_ASSET__ee3bfa14__"